// src/components/common/ModalDialog.tsx

import React, { ReactNode } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface ModalDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: () => void;
    title: string;
    children: ReactNode;
    saveText?: string;
    cancelText?: string;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    fullWidth?: boolean;
    disabled?: boolean;
    loading?: boolean;
}

const ModalDialog: React.FC<ModalDialogProps> = ({
                                                     open,
                                                     onClose,
                                                     onSave,
                                                     title,
                                                     children,
                                                     saveText = 'Сохранить',
                                                     cancelText = 'Отмена',
                                                     maxWidth = 'sm',
                                                     fullWidth = true,
                                                     disabled = false,
                                                     loading = false,
                                                 }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        p: 0,
                    },
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pb: 1,
                }}
            >
                <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent
                sx={{
                    pt: 2,
                    pb: 2,
                }}
            >
                {children}
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
                <Button onClick={onClose} variant="outlined" color="inherit">
                    {cancelText}
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                    disabled={disabled || loading}
                >
                    {loading ? 'Сохранение...' : saveText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDialog;